const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://api.atlaspood.ir";
export const API_BASE_URL = rawBaseUrl.replace(/\/$/, "");
const rawImgBaseUrl =
  process.env.REACT_APP_API_BASE_URL_IMG || process.env.REACT_APP_API_BASE_URL || API_BASE_URL;
export const IMG_BASE_URL = rawImgBaseUrl.replace(/\/$/, "");

export const API_KEY = "477f46c6-4a17-4163-83cc-29908d";
export function apiUrl(path = "") {
  if (!path) return API_BASE_URL;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
}
export function imgUrl(path = "") {
  if (!path) return IMG_BASE_URL;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${IMG_BASE_URL}${normalized}`;
}

/** @param {string} path @param {string} [apiKey] */
export function apiUrlWithKey(path, apiKey = API_KEY) {
  return `${apiUrl(path)}?apiKey=${apiKey}`;
}

// Sewing / orders
export const baseURLModel = apiUrl("/SewingModel/GetById");
export const baseURLGetModels = apiUrl("/SewingModel/GetAll");
export const baseURLGetModelsWithKey = apiUrlWithKey("/SewingModel/GetAll");
export const baseURLSewingModelEdit = apiUrl("/SewingModel/Edit");
export const baseURLFilterHangingStyle = apiUrl("/SewingModel/GetAllModelName");
export const baseURLFilterPatternSewing = apiUrl("/SewingModel/GetDesignPatterns");
export const baseURLFilterTypeSewing = apiUrl("/SewingModel/GetDesignTypes");
export const baseURLFilterOpacitySewing = apiUrl("/SewingModel/GetDesignOpacities");
export const baseURLFabrics = apiUrl("/Sewing/GetModelFabric");
export const baseURLGetRail = apiUrl("/Sewing/GetModelRail");
export const baseURLZipCode = apiUrl("/Sewing/HasInstall");
export const baseURLPrice = apiUrl("/SewingOrder/GetPrice");
export const baseURGetProject = apiUrl("/SewingOrder/GetById");
export const baseURLGetProjects = apiUrl("/SewingOrder/GetAll");
export const baseURLEditProject = apiUrl("/SewingOrder/Edit");
export const baseURLAddProject = apiUrl("/SewingOrder/Add");
export const baseURLDeleteSewingProject = apiUrl("/SewingOrder/Delete");
export const baseURLUploadImg = apiUrl("/SewingOrderAttachment/ImageUpload");
export const baseURLUploadPdf = apiUrl("/SewingOrderAttachment/PdfUpload");
export const baseURLDeleteFile = apiUrl("/SewingOrderAttachment/Delete");
export const baseURLGetDkScarfRule = apiUrl("/Sewing/GetDkScarfRule");

// Cart
export const baseURLGetCart = apiUrl("/cart/GetAll");
export const baseURLGetRemoteNames = apiUrl("/cart/GetRemoteNames");
export const baseURLGetCartCount = apiUrl("/cart/GetCount");
export const baseURLGetSwatchs = apiUrl("/cart/GetSwatchs");
export const baseURLAddProduct = apiUrl("/Cart/Add");
export const baseURLAddSwatch = apiUrl("/Cart/Add");
export const baseURLAddMulti = apiUrl("/Cart/AddMultiple");
export const baseURLAddProjectToCart = apiUrl("/cart/AddSewingOrder");
export const baseURLDeleteBasketProject = apiUrl("/Cart/DeleteItem");
export const baseAddCountProject = apiUrl("/Cart/AddSewingOrderCount");
export const baseURLSaveForLaterBasketProject = apiUrl("/Cart/SaveForLater");
export const baseURLChangeZipcode = apiUrl("/Cart/ChangeZipCode");
export const baseURLHasZipCode = apiUrl("/Cart/GetAlreadyZipCode");
export const baseURLAddDiscount = apiUrl("/Cart/AddDiscountCode");
export const baseURLAddDiscountGuest = apiUrl("/Cart/AddGuestDiscountCode");
export const baseURLDeleteDiscount = apiUrl("/Cart/DeleteDiscountCode");
export const baseURLDeleteDiscount2 = apiUrl("/Cart/DeleteGuestDiscountCode");

// Products / favorites
export const baseURLCatProduct = apiUrl("/Product/Get");
export const baseURLCatProduct2 = apiUrl("/Product/GetByName");
export const baseURLGetPrice = apiUrl("/Product/GetPrice");
export const baseURLJoinWaitingList = apiUrl("/Product/JoinWaitingList");
export const baseURLSaveProduct = apiUrl("/Favorite/Add");
export const baseURLGetFavorites = apiUrl("/Favorite/Get");
export const baseURLDeleteFavorite = apiUrl("/Favorite/Delete");

// Website pages / menu
export const baseURLCats = apiUrl("/WebsitePage/GetDetailByName");
export const baseURLGetPage = apiUrl("/WebsitePage/GetDetailById");
export const baseURLGetPages = apiUrl("/WebsitePage/GetAll");
export const baseURLAddPage = apiUrl("/WebsitePage/Add");
export const baseURLEditPage = apiUrl("/WebsitePage/Edit");
export const baseURLDeletePage = apiUrl("/WebsitePage/Delete");
export const baseURLPageItems = apiUrl("/WebsitePageItem/GetAll");
export const baseURLMenu = apiUrl("/WebsiteMenu/GetByChildren");
export const baseURLMenuSaveAll = apiUrl("/WebsiteMenu/SaveAll");
export const baseURLMenuSave = apiUrl("/WebsiteMenu/Save");
export const baseURLMenuDeleteAll = apiUrl("/WebsiteMenu/DeleteAll");
export const baseURLMenuImageUpload = apiUrl("/WebsiteMenu/ImageUploder");

// Product groups
export const baseURLProductGroups = apiUrl("/ProductGroup/GetAll");
export const baseURLGetProductGroup = apiUrl("/ProductGroup/GetAll");
export const ProductGroupSetPageName = apiUrl("/ProductGroup/SetPageName");
export const baseURLGetProductGroupPage = apiUrl("/ProductGroup/GetPageProductGroup");

// Filters
export const baseURLFilterColor = apiUrl("/Color/GetBaseColors");
export const baseURLFilterPattern = apiUrl("/BaseType/GetDesignPattern");
export const baseURLFilterType = apiUrl("/BaseType/GetDesignType");
export const baseURLFilterPrice = apiUrl("/BaseType/GetPriceLevel");
export const baseURLFilterOpacity = apiUrl("/BaseType/GetDesignOpacity");
export const baseURLFilterSize = apiUrl("/BaseType/GetProductSize");

// Website settings
export const baseURLGet = apiUrl("/WebsiteSetting/GetBanner");
export const baseURLSaveBanner = apiUrl("/WebsiteSetting/SaveBanner");
export const baseURLFreeShipping = apiUrl("/WebsiteSetting/GetFreeShippingAmount");
export const baseURLGetSlider = apiUrl("/WebsiteSetting/GetSlider");
export const baseURLGetSliderWithKey = apiUrlWithKey("/WebsiteSetting/GetSlider");
export const baseURLSaveSlider = apiUrl("/WebsiteSetting/SaveSlider");
export const baseURLSliderImageUpload = apiUrl("/WebsiteSetting/ImageUploder");

// Auth / user
export const baseURLLogin = apiUrl("/login");
export const baseURLRegister = apiUrl("/user/register");
export const baseURLCheckEmail = apiUrl("/user/UserNameIsAvailable");
export const baseURLReset = apiUrl("/user/SendResetPasswordEmail");
export const baseURLActivate = apiUrl("/user/Activate");
export const baseURLCheckResetPassword = apiUrl("/user/CheckResetPassword");
export const baseURLResetPassword = apiUrl("/user/ResetPassword");
export const baseURLGetAddress = apiUrl("/user/GetAddress");
export const baseURLDeleteAddress = apiUrl("/user/DeleteAddress");
export const baseURLEditAddress = apiUrl("/user/EditAddress");
export const baseURLAddAddress = apiUrl("/user/AddAddress");

// Location
export const baseURLGetStates = apiUrl("/City/GetStates");
export const baseURLGetCities = apiUrl("/City/GetCities/");

// Checkout
export const checkoutPayment = apiUrl("/Checkout/Payment");
export const baseURLGetShippingMethods = apiUrl("/Checkout/GetShippingMethods");
